import * as PrivacyPolicyDocumentUploads from "$lib/data/generated/uploads/privacy policy/Document/uploads.js";

export const uploads = {
  ...PrivacyPolicyDocumentUploads.uploads
};
